<template>
    <div class="footer" :class="{ 'overlap-all' : isEventVideoVisible }">
        <transition name="show">
          <div class="event-video-popup" v-if="isEventVideoVisible" @click.stop="closeEventVideo($event)">
            <div class="event-video">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/D1kkmTWlFNI" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>
          </div>
        </transition>
        <!-- <router-link to="/news/Aluminium2018" class="events-wrapper">
          <img class="events-img" src="/static/img/events/1.jpg" alt="Events">
          <img class="events-img-mobile" src="/static/img/events/1m.jpg" alt="Events">
        </router-link> -->
        <a href="https://www.facebook.com/groups/2198191030504509/"   target="_blank" class="seatbelts seatbelts-left" >
          <div class="seatbelts-content">
            <div class="seatbelts-texts">
              <p>От 1 октомври стартира инициатива по безопасност на децата в автомобилите <span class="strong">„С предпазен колан на задната седалка“</span> в градовете Шумен, Каспичан и Плиска.</p>
              <img class="seatbelts-gif mobile" src="/static/img/home/seatbelts.gif" alt="Seatbelts campaign">
              <a class="see-more-btn" href="https://www.facebook.com/groups/2198191030504509/" target="_blank"><span class="alcomet">r</span> Разберете повече</a>
            </div>
            <img class="seatbelts-gif desktop" src="/static/img/home/seatbelts.gif" alt="Seatbelts campaign">
          </div>
        </a>

      <a href="https://www.facebook.com/groups/2198191030504509/" target="_blank" class="seatbelts seatbelts-right" >
        <div class="seatbelts-content seatbelts-content1">
          <div class="seatbelts-texts">
            <p><span class="strong">„За чист Шумен“</span> – най-новата екоинициатива на „Алкомет“. "Алкомет“ организира местна, екологично ориентирана инициатива под надслов „С грижа и обич за Шумен! Нашият град! Да го запазим чист за поколенията!“</p>
            <img class="seatbelts-gif mobile" src="/static/img/home/seatbelts.gif" alt="Seatbelts campaign">
            <a class="see-more-btn" href="https://www.alcomet.bg/news/for-a-clean-Shumen-a-new-environmental-initiative-of-Alcomet" target="_blank"><span class="alcomet">r</span> Разберете повече</a>
          </div>
          <img class="seatbelts-gif desktop" src="/static/img/home/seatbelts1_1.jpg" alt="Seatbelts campaign">
        </div>
      </a>

        <div class="footer-top">
            <!-- <div class="footer-subscribe">
                <div class="footer-titles">
                    <h3>Subscribe to</h3>
                    <h2>ALCOMET NEWSLETTER</h2>
                </div>
                <div class="footer-subscribe-input-wrapper">
                    <div class="footer-subscribe-input-container">
                        <span class="footer-subscribe-img-container">
                            <img src="/static/img/mail.svg" alt="">
                        </span>
                        <input type="text" placeholder="Enter your e-mail here" id="subscribeInput">
                        <a class="footer-subscribe-signup">SIGN UP</a>
                    </div>
                    <p class="agreement">By signing up, I acknowledge the <router-link class="agreement-link" to="/terms-of-use">alcomet Terms and conditions</router-link></p>
                </div>
            </div> -->
            <div class="footer-top-nav">
                <div class="footer-top-nav-list">
                    <h6>За нас</h6>
                    <ul>
                        <li><router-link class="top-nav-item" to="/about-the-company/about-us">За нас</router-link></li>
                        <li><router-link class="top-nav-item" to="/about-the-company/mission-and-values">Мисия и ценности</router-link></li>
                        <li><router-link class="top-nav-item" to="/about-the-company/key-figures">Компанията в цифри</router-link></li>
                        <!-- <li><router-link class="top-nav-item" to="/about-the-company/r-and-d">Развойна дейност</router-link></li> -->
                        <li><router-link class="top-nav-item" to="/about-the-company/rolling-plant">Валцово производство</router-link></li>
                        <li><router-link class="top-nav-item" to="/about-the-company/extrusion-plant">Пресово производство</router-link></li>
                        <li><router-link class="top-nav-item" to="/about-the-company/timeline">История</router-link></li>
                    </ul>
                </div>
                <div class="footer-top-nav-list">
                    <h6>Пазари</h6>
                    <ul>
                        <li><router-link class="top-nav-item" to="/markets/building-and-architecture">Строителство и архитектура</router-link></li>
                        <li><router-link class="top-nav-item" to="/markets/automotive">Автомобилостроене</router-link></li>
                        <li><router-link class="top-nav-item" to="/markets/transportation">Транспорт</router-link></li>
                        <li><router-link class="top-nav-item" to="/markets/packaging">Опаковки</router-link></li>
                        <li><router-link class="top-nav-item" to="/markets/distribution">Дистрибуция</router-link></li>
                        <!-- <li><router-link class="top-nav-item" to="/markets/other-industries">Other Industries</router-link></li> -->
                    </ul>
                </div>
                <div class="footer-top-nav-list">
                    <h6>Продукти</h6>
                    <ul>
                        <li><router-link class="top-nav-item" to="/products/rolled/household-foil">Валцови продукти</router-link></li>
                        <li><router-link class="top-nav-item" to="/products/extruded/profiles-for-building-and-architecture">Пресови продукти</router-link></li>
                    </ul>
                </div>
                <div class="footer-top-nav-list">
                    <h6>Устойчиво развитие</h6>
                    <ul>
                        <li><router-link class="top-nav-item" to="/sustainability/environment">Околна среда</router-link></li>
                        <li><router-link class="top-nav-item" to="/sustainability/health-and-safety">Здраве и безопасност</router-link></li>
                        <li><a href="/static/files/sustainability/Информация-по-чл-20-зa-планирани-мерки-за-безопасност-при-аварии-с-ХВС.pdf" class="top-nav-item" target="_blank" download>Планирани мерки за безопасност при аварии с ХВС</a></li>
                        <li><router-link class="top-nav-item" to="/sustainability/responsibility">Социална отговорност</router-link></li>
                        <li><router-link class="top-nav-item" to="/sustainability/sustainability-reports">Доклади за устойчиво развитие</router-link></li>
                    </ul>
                </div>
                <div class="footer-top-nav-list">
                    <h6>Инвеститори</h6>
                    <ul>
                        <li><router-link class="top-nav-item" to="/investors/management">Корпоративно управление</router-link></li>
                        <li><router-link class="top-nav-item" to="/investors/financial-statements">Финансови отчети</router-link></li>
                        <li><router-link class="top-nav-item" to="/investors/general-meetings">Общи събрания</router-link></li>
                        <li><router-link class="top-nav-item" to="/investors/calendar">Календар на инвеститорите</router-link></li>
                        <li><router-link class="top-nav-item" to="/investors/shares">Акции</router-link></li>
                        <li><router-link class="top-nav-item" to="/investors/presentations">Презентации</router-link></li>
                    </ul>
                </div>
                <div class="footer-top-nav-list">
                    <h6>Новини</h6>
                    <ul>
                        <li><router-link class="top-nav-item" to="/news">Новини</router-link></li>
                        <!-- <li><router-link class="top-nav-item" to="/news">Archive</router-link></li> -->
                    </ul>
                </div>
                <div class="footer-top-nav-list">
                    <h6>Контакти</h6>
                    <ul>
                        <li><router-link class="top-nav-item" to="/contacts/sales-department">Продажби</router-link></li>
                        <li><router-link class="top-nav-item" to="/contacts/supply-chains">Доставки</router-link></li>
                        <li><router-link class="top-nav-item" to="/contacts/other-contacts">Други контакти</router-link></li>
                        <li><router-link class="top-nav-item" to="/contacts/sales-department">Райони</router-link></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-above">
            <div class="footer-logo-wrapper">
              <router-link class="footer-logo-link" to="/"><img class="footer-logo" src="/static/img/logo_white.svg" alt="Алкомет"></router-link>
              <span>&copy; Alcomet 2018 Всички права запазени!</span>
            </div>
            <div class="footer-above-right">
                <!-- <a class="footer-lang">
                    <img class="footer-above-right-globe" src="/static/img/lng.svg" alt="Lang">
                    English
                    <img class="footer-above-right-arrow" src="/static/img/down.svg" alt="Lang">
                </a> -->
                <ul>
                    <li>
                        <router-link class="nav-item" to="/download-center/catalogues">Download център</router-link>
                    </li>
                    <li>
                        <router-link class="nav-item" to="/sitemap">Карта на сайта</router-link>
                    </li>
                    <li>
                        <router-link class="nav-item" to="/disclosure-policy">Политика за предоставяне на информация</router-link>
                    </li>
                    <li>
                        <router-link class="nav-item" to="/personal-data">Лични данни</router-link>
                    </li>
                    <li>
                        <router-link class="nav-item" to="/terms-of-use">Общи условия</router-link>
                    </li>
                </ul>
            </div>
        </div>
        <!-- <div class="footer-bottom">
            <p>&copy; ALCOMET 2018 All Rights Reserved</p>
            <a href="https://cdots-corporation.com" target="_blank">SOLUTION DELIVERED BY CDOTS</a>
        </div> -->
    </div>
</template>

<script>
export default {
  data() {
    return {
      isEventVideoVisible: false
    };
  },
  methods: {
    closeEventVideo(ev) {
      if (ev.target.classList.contains("event-video-popup")) {
        this.isEventVideoVisible = false;
      }
    }
  }
};
</script>

<style scoped>
.footer {
  padding-top: 40px;
  position: relative;
  z-index: 1;
}
/* FIRST FOOTER SECTION */
.footer-top {
  background-color: #dde7ee;
  border-radius: 5px;
  /* height: 475px; */
  display: flex;
  flex-direction: column;
  margin: 0 40px;
  padding: 0 80px;
  position: relative;
  width: calc(100% - 80px);
  z-index: 1;
}
.event-video-popup {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000000;
}
.event-video {
  min-width: 600px;
  max-width: 600px;
}
.event-video iframe {
  width: 100%;
}
.events-wrapper {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 40px;
  padding: 0 40px;
}
/* SEATBELTS */
.seatbelts {
  display: block;
  height: 280px;
  padding: 0 40px;
  margin-bottom: 40px;
  width: 100%;
}
@media screen and (min-width:1200px){
  .seatbelts-left { width:50%; float:left; }
  .seatbelts-right { width:50%; float:right; }
}
@media screen and (min-width:1200px) and (max-width:1600px){
  .seatbelts-content p {font-size:16px !important;}
  .seatbelts-content {padding:0 15px !important;}
}

.seatbelts-content {
  align-items: center;
  background-image: url("/static/img/home/seatbelts.jpg");
  background-size: cover;
  background-position: left;
  border-radius: 6px;
  display: flex;
  height: 100%;
  justify-content: space-between;
  padding: 0 75px;
  width: 100%;
}
.seatbelts-content1 {
  background-image: url("/static/img/home/seatbelts1.jpg") !important;
}


.seatbelts-gif {
  border-radius: 6px;
  width: 300px;
}
.seatbelts-texts {
  margin-top: 50px;
  width: 50%;
}
.seatbelts p {
  font-size: 20px;
}
.seatbelts-right p {
  font-size: 18px !important;
}
.see-more-btn {
  align-items: center;
  border: 1px solid #588cc1;
  border-radius: 30px;
  display: inline-flex;
  font-size: 14px;
  font-weight: 700;
  height: 35px;
  justify-content: center;
  line-height: initial;
  margin: 20px 0 0;
  overflow: hidden;
  padding: 8px 20px 8px 10px;
  position: relative;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.see-more-btn span {
  margin-right: 10px;
}
.see-more-btn:hover {
  background-color: #dde7ee;
}
h1 {
  color: #004787;
  font-size: 36px;
  font-weight: 300;
  margin: 50px 0;
}
.events-wrapper img {
  border-radius: 5px;
  min-height: 1px;
  height: auto;
  width: 100%;
}
.footer-subscribe {
  align-items: center;
  display: flex;
  height: 200px;
  justify-content: space-between;
  position: relative;
}
.footer-titles h3 {
  font-size: 20px;
}
.footer-titles h2 {
  font-size: 22px;
  font-weight: 700;
}
.footer-subscribe-input-wrapper {
  margin-top: 20px;
  width: 600px;
}
.footer-subscribe-input-container {
  align-items: center;
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  height: 60px;
  width: 600px;
}
.footer-subscribe-img-container {
  align-items: center;
  display: flex;
  height: 70px;
  justify-content: center;
  width: 70px;
}
.footer-subscribe-input-container input {
  border: 0;
  color: #01427c;
  font-size: 16px;
  height: 52px;
  padding-right: 30px;
  width: calc(100% - 220px);
}
.footer-subscribe-input-container input::-webkit-input-placeholder {
  color: #588cc1;
}
.footer-subscribe-input-container input::-moz-placeholder {
  color: #588cc1;
}
.footer-subscribe-input-container input:-moz-placeholder {
  color: #588cc1;
}
.footer-subscribe-input-container :-ms-input-placeholder {
  color: #588cc1;
}
.footer-subscribe-signup {
  align-items: center;
  border-left: 1px solid #01427c;
  font-size: 16px;
  font-weight: 400;
  display: flex;
  height: 52px;
  justify-content: center;
  width: 136px;
}
.agreement {
  font-size: 12px;
  font-weight: 500;
  margin-top: 20px;
  text-align: right;
  text-transform: uppercase;
}
.agreement-link {
  text-decoration: underline;
}
/* FOOTER BIG NAV */
.footer-top-nav {
  /* height: 275px; */
  display: flex;
}
.footer-top-nav-list {
  width: 14.24%;
  /* padding: 0 30px 30px; */
  padding: 30px;
}
.footer-top-nav-list:first-child {
  padding-left: 0;
}
.footer-top-nav-list:last-child {
  padding-right: 0;
}
.footer-top-nav-list h6 {
  font-size: 14px;
  font-weight: 700;
  margin: 30px 0;
}
.footer-top-nav-list ul li {
  display: block;
  margin: 8px 0;
}
.top-nav-item {
  font-size: 14px;
}
/* SECOND(BLUE) FOOTER SECTION */
.footer-above {
  align-items: center;
  background-color: #01427c;
  display: flex;
  height: 230px;
  justify-content: space-between;
  margin-top: -100px;
  padding: 120px 120px 20px;
}
.footer-logo {
  width: 185px;
  height: auto;
}
.footer-logo-link {
  display: inline-block;
  min-height: 1px; /* for the sake of IE */
}
.footer-logo-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.footer-logo-wrapper > span {
  color: #fff;
  font-size: 12px;
  margin-top: 6px;
}
.footer-above-right {
  align-items: center;
  display: flex;
}
/* LANGUAGE BUTTON */
.footer-lang {
  align-items: center;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  margin-right: 30px;
  display: flex;
}
.footer-above-right-globe {
  height: 26px;
  margin-right: 5px;
  width: 26px;
}
.footer-above-right-arrow {
  height: 9px;
  margin-left: 16px;
  width: 14px;
}
/* LAST NAV */
.nav-item {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  margin-left: 30px;
}
/* LAST FOOTER SECTION */
.footer-bottom {
  align-items: center;
  display: flex;
  justify-content: space-between;
  height: 60px;
  padding: 0 120px;
}
.footer-bottom p,
.footer-bottom a {
  font-size: 12px;
}
.events-img-mobile {
  display: none;
}
.overlap-all {
  z-index: 1000;
}
.show-enter-active,
.show-leave-active {
  transition: all 0.4s ease;
}
.show-leave-to,
.show-enter {
  opacity: 0;
}
.mobile {
  display: none;
}
/* RESPONSIVE */
@media screen and (max-width: 1700px) {
  .footer-subscribe {
    justify-content: space-between;
  }
  .footer-subscribe-input-wrapper {
    position: static;
  }
  .footer-top-nav-list {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media screen and (max-width: 1440px) {
  .footer-top-nav-list h6 {
    margin-top: 15px;
  }
  .footer-top-nav-list {
    padding-left: 0;
    padding-right: 10px;
  }
  .seatbelts p {
    font-size: 18px;
  }
}
@media screen and (max-width: 1280px) {
  .footer-top {
    padding: 0 40px 40px;
  }
  .footer-subscribe-input-container {
    margin-left: 15px;
    width: 585px;
  }
  .seatbelts p {
    font-size: 16px;
  }
  .seatbelts-gif {
    width: 250px;
  }
  .see-more-btn {
    font-size: 12px;
  }
}
@media screen and (max-width: 1000px) {
  .top-nav-item,
  .footer-top-nav,
  .footer-above-right,
  .events-img,
  .footer-top {
    display: none;
  }
  .events-img-mobile {
    display: inline;
  }
  .footer {
    padding-top: 30px;
  }
  .events-wrapper {
    margin-bottom: 30px;
    padding: 0 30px;
  }
  .footer-top {
    height: initial;
    margin: 0 30px;
    padding: 30px;
    width: calc(100% - 60px);
  }
  .footer-subscribe {
    align-items: flex-start;
    flex-direction: column;
    height: initial;
  }
  .footer-subscribe-input-wrapper {
    width: 100%;
  }
  .footer-subscribe-input-container {
    margin: 0;
    width: 100%;
  }
  .footer-above {
    /* padding: 120px 30px 70px; */
    height: initial;
    margin-top: initial;
    padding: 20px 30px 70px;
  }
  .footer-logo-wrapper {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
  .footer-titles h3 {
    font-size: 18px;
  }
  .seatbelts {
    padding: 0 30px;
    margin-bottom: 30px;
  }
  .seatbelts p {
    /* font-size: 14px; */
  }
  .seatbelts-gif {
    width: 200px;
  }
}
@media screen and (max-width: 800px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: inline;
  }
  .seatbelts-content {
    flex-direction: column;
    padding: 30px;
  }
  .seatbelts {
    height: initial;
  }
  .seatbelts p {
    text-align: center;
  }
  .seatbelts-texts {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: 0;
    width: 100%;
  }
  .seatbelts-gif {
    margin: 20px 0;
  }
  .see-more-btn {
    margin: 0;
  }
}
@media screen and (max-width: 600px) {
  .footer-titles h3,
  .footer-subscribe-signup {
    font-size: 14px;
  }
  .footer-subscribe {
    align-items: center;
  }
  .footer-titles h3 {
    text-align: center;
  }
  .footer-titles h2 {
    font-size: 16px;
    text-align: center;
  }
  .agreement {
    font-size: 10px;
    text-align: center;
  }
  .footer-subscribe-img-container {
    width: 40px;
  }
  .footer-subscribe-img-container img {
    width: 20px;
  }
  .footer-subscribe-input-container {
    height: 40px;
  }
  .footer-subscribe-input-container input {
    font-size: 14px;
    height: 40px;
    padding-right: 10px;
    width: calc(100% - 125px);
  }
  .footer-subscribe-signup {
    height: 30px;
    width: 75px;
  }
  .footer-logo {
    width: 100px;
  }
  .footer-logo-wrapper > span {
    font-size: 10px;
    margin: 0;
  }
  .footer-above {
    height: initial;
  }
  .event-video {
    min-width: 80%;
    max-width: 80%;
  }
}
@media screen and (max-width: 440px) {
  .footer-subscribe-img-container {
    display: none;
  }
  .footer-subscribe-input-container input {
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    padding: 0 10px;
    width: calc(100% - 75px);
  }
  .footer-logo-wrapper {
    flex-direction: column;
  }
  .footer-subscribe-input-container input {
    font-size: 12px;
  }
  .footer-titles h3,
  .footer-subscribe-signup {
    font-size: 11px;
  }
  .agreement {
    margin-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Footer.vue